module.exports = __webpack_public_path__ + "static/img/rongguiLogo.0f16b2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/rongguiLogo.png
// module id = hy4q
// module chunks = 63